import { z } from "zod";
import { baseSpecShape, registerShell } from "./base.js";
export const orderSpecSchema = z.object({
    type: z.literal("order"),
    ...baseSpecShape,
    steps: z
        .array(z.string().min(1).max(60))
        .min(3)
        .max(5)
        .describe("Given in the CORRECT order. The client shuffles for display."),
});
export const orderShell = registerShell({
    id: "order",
    version: 1,
    summary: "Tap steps into sequence.",
    chooseWhen: "The idea is a process or a causal chain where the order is the whole point — how something happens, step by step.",
    interaction: "puts the steps in the right order",
    invitation: "A few steps, muddled up. Put them back in order.",
    schema: orderSpecSchema,
    required: ["steps"],
    properties: {
        steps: {
            type: "array",
            minItems: 3,
            maxItems: 5,
            description: "Given in the CORRECT order. The client shuffles for display.",
            items: { type: "string", maxLength: 60 },
        },
    },
    semanticIssues(spec) {
        const issues = [];
        const seen = new Set(spec.steps.map((s) => s.trim().toLowerCase()));
        if (seen.size !== spec.steps.length) {
            issues.push("order steps must all be different.");
        }
        // A shuffle that can land back on the given order makes the check trivially
        // winnable by tapping top to bottom, so the client needs room to move.
        if (spec.steps.length < 3) {
            issues.push("order needs at least 3 steps to be worth doing.");
        }
        return issues;
    },
    example: {
        type: "order",
        prompt: "Tap what happens first, then next, then last.",
        steps: [
            "Rock deep underground melts into magma",
            "The magma pushes up through a crack",
            "It bursts out of the top as lava",
        ],
        right: "That's it! Melt, push, burst.",
        wrong: "Not quite — start with the melting, way down deep.",
    },
});
//# sourceMappingURL=order.js.map